if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      getCartSectionIds() {
        const sectionIds = ['cart-drawer'];
        const ajaxSections = window.ajaxCart?.getSectionsToRender?.();

        if (ajaxSections?.size) {
          ajaxSections.forEach((_, id) => {
            if (!sectionIds.includes(id)) sectionIds.push(id);
          });
        }

        return sectionIds;
      }

      appendSectionsToRequest(target, isJsonPayload) {
        const sectionIds = this.getCartSectionIds();

        if (!sectionIds.length) return;

        if (isJsonPayload) {
          target.sections = sectionIds;
          target.sections_url = window.location.pathname;
        } else {
          target.append('sections', sectionIds);
          target.append('sections_url', window.location.pathname);
        }

        if (this.cart?.setActiveElement) {
          this.cart.setActiveElement(document.activeElement);
        }
      }

      buildCartItems(formData, addonCheckboxes) {
        const items = [];
        const mainItem = {
          id: parseInt(formData.get('id'), 10),
          quantity: parseInt(formData.get('quantity') || 1, 10),
        };

        const properties = {};
        for (const [key, value] of formData.entries()) {
          if (key.startsWith('properties[') && value) {
            properties[key.slice(11, -1)] = value;
          }
        }

        if (Object.keys(properties).length) {
          mainItem.properties = properties;
        }

        const sellingPlan = formData.get('selling_plan');
        if (sellingPlan) {
          mainItem.selling_plan = parseInt(sellingPlan, 10);
        }

        items.push(mainItem);

        addonCheckboxes.forEach((checkbox) => {
          items.push({
            id: parseInt(checkbox.dataset.variantId, 10),
            quantity: 1,
          });
        });

        return items;
      }

      updateCartDrawer(response) {
        const sectionHtml = response.sections?.['cart-drawer'];
        if (!sectionHtml) return;

        const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
        const newCartDrawer = parsed.querySelector('#CartDrawer');
        const cartDrawer = document.querySelector('#CartDrawer');

        if (newCartDrawer && cartDrawer) {
          cartDrawer.innerHTML = newCartDrawer.innerHTML;
        }

        const drawerEl = document.querySelector('cart-drawer');
        if (drawerEl) {
          drawerEl.classList.remove('is-empty');
        }
      }

      updateCartCount() {
        fetch(`${window.routes.cart_url}.js`)
          .then((response) => response.json())
          .then((cart) => {
            document.querySelectorAll('.site-header__cart').forEach((link) => {
              let badge = link.querySelector('.site-header__cart-count');

              if (cart.item_count > 0) {
                if (!badge) {
                  badge = document.createElement('span');
                  badge.className = 'site-header__cart-count';
                  badge.setAttribute('data-ajax-cart-bind-state', 'cart.item_count');
                  link.appendChild(badge);
                }
                badge.textContent = String(cart.item_count);
              } else if (badge) {
                badge.remove();
              }
            });

            document.body.classList.toggle('js-ajax-cart-empty', cart.item_count === 0);
          })
          .catch(() => {});
      }

      handleCartSuccess(response) {
        if (window.ajaxCart?.renderSections && response.sections) {
          window.ajaxCart.renderSections(response.sections);
        }

        this.updateCartCount();
        document.body.classList.toggle('js-ajax-cart-empty', false);

        const drawer = document.querySelector('cart-drawer');
        if (drawer?.renderContents) {
          drawer.renderContents(response);
          return;
        }

        this.updateCartDrawer(response);

        if (typeof window.ajaxCart?.toggleCartDrawer === 'function') {
          if (!document.body.classList.contains('template--cart')) {
            window.ajaxCart.toggleCartDrawer(true);
          }
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');
        this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

        const formData = new FormData(this.form);
        const addonCheckboxes = document.querySelectorAll(
          `[data-product-addons="${this.form.id}"] [data-product-addon]:checked`
        );
        const hasAddons = addonCheckboxes.length > 0;
        const hasCartDrawer = Boolean(document.querySelector('cart-drawer'));
        const hasCartNotification = Boolean(document.querySelector('cart-notification'));

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        if (hasAddons) {
          const payload = {
            items: this.buildCartItems(formData, addonCheckboxes),
          };

          if (hasCartDrawer || hasCartNotification) {
            this.appendSectionsToRequest(payload, true);
          }

          config.body = JSON.stringify(payload);
        } else {
          delete config.headers['Content-Type'];

          if (hasCartDrawer || hasCartNotification) {
            this.appendSectionsToRequest(formData, false);
          }

          config.body = formData;
        }

        fetch(`${window.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            if (!hasCartDrawer && !hasCartNotification && !window.ajaxCart?.toggleCartDrawer) {
              window.location.href = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.handleCartSuccess(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.handleCartSuccess(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner')?.classList.add('hidden');
            this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
